import { render, staticRenderFns } from "./SimpleSelect.vue?vue&type=template&id=65cbc078&scoped=true&"
import script from "./SimpleSelect.vue?vue&type=script&lang=js&"
export * from "./SimpleSelect.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSelect.vue?vue&type=style&index=0&id=65cbc078&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cbc078",
  null
  
)

export default component.exports